<template>
  <div class="test-root">
    <!-- device status -->
    <div>
      <div class="layer">
        <div>{{userAgent}}</div>
        <div v-if="userAgentData">{{userAgentData}}</div>
        <div v-if="userScreenData" class="info">
          <span>screen</span>
          <span>{{userScreenData}}</span>
        </div>
        <label v-if="Hardware.cpu" class="info">
          <span>cpu</span>
          <span>{{Hardware.cpu}}</span>
        </label>
        <label v-if="Hardware.battery.instance" class="info">
          <span>battery</span>
          <span>{{Hardware.battery.charging?'charging,':''}}{{Hardware.battery.level*100}}%</span>
        </label>
        <label class="info">
          <span :style="{color: Hardware.network.online ? '' : 'red'}">{{Hardware.network.online ? 'online' : 'offline'}}</span>
        </label>
        <label v-if="Hardware.network.effectiveType" class="info">
          <span>connType</span>
          <span>{{Hardware.network.effectiveType}}</span>
        </label>
        <label v-if="Hardware.network.lastChangeDateTime" class="info">
          <span>lastChage</span>
          <span>{{Hardware.network.lastChangeDateTime.toTimeString().substring(0, 8)}}</span>
        </label>
      </div>
    </div>

    <!-- media devices -->
    <div>
      <div>
        video:<select v-model="Device.selected.video">
          <option
            v-for="Device in Device.list.video" :key="Device.deviceId"
            :value="Device.deviceId">{{Device.label}}</option>
        </select>
        <!--
        audio:<select v-model="Device.selected.audio">
            <option
                v-for="Device in Device.list.audio"
                :value="Device.deviceId">{{Device.label}}</option>
        </select>
        -->
      </div>
      <div>
        <button @click="playVideo">play</button>
        <button @click="stopVideo">stop</button>
        <button @click="ui.oriSize=!ui.oriSize">ori size</button>
        <div v-if="this.trackInfo.settings">
          <textarea style="width: 660px;"
                    v-model="trackInfo.settings"
          ></textarea>
          <textarea style="width: 660px; height: 30px;"
                    v-model="trackInfo.constraints"
          ></textarea>
          <button @click="applyVideoConstraints">apply</button>
        </div>
      </div>
    </div>

    <!-- video preview -->
    <div ref="videoLayer" class="layer preview-video-layer">
      <video autoplay playsinline crossorigin="anonymous"
             ref="prevVideo"
             @loadedmetadata="setTrackInfo"
             @play="onVideoPlay"
      ></video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CameraTestBase',
  data () {
    return {
      userAgent: navigator.userAgent,
      userAgentData: null,
      userScreenData: null,
      Hardware: {
        cpu: 0,
        battery: {
          instance: null,
          level: -1,
          charging: null,
          chargingTime: -1,
        },
        network: {
          online: true,
          effectiveType: null,
          lastChangeDateTime: null
        }
      },
      Device: {
        selected: {
          video: '', audio: ''
        },
        list: {
          video:[], audio:[]
        },
        settings: {
          video: {
            res: '360p',
            resSets: (() => {
              const common = {
                frameRate: 30
              }
              const sets = {
                '180p': {
                  width: 320, height: 180
                },
                '360p': {
                  width: 640, height: 360
                },
                '720p': {
                  width: 1280, height: 720
                },
                '1080p': {
                  width: 1920, height: 1080
                },
                '1080p-vertical': {
                  width: 1080 * (1080 / 1920), height: 1080,
                  aspectRatio: 1080 / 1920
                }
              }
              for(let key in sets){
                sets[key] = Object.assign({}, common, sets[key])
              }
              return sets;
            })()
          }
        }
      },
      trackInfo: {
        settings: null,
        constraints: null
      },
    }
  },
  watch: {
  },
  computed: {
  },
  async created() {
    window.$vue = this;

    (async () => {
      try{
        if(!navigator.userAgentData) return;
        const info = await navigator.userAgentData.getHighEntropyValues([
          'platform',
          'platformVersion',
          'model',
          'architecture',
          'bitness',
          'uaFullVersion'
        ]);
        this.userAgentData = JSON.stringify(info);
      }catch(e){
        console.error(e);
        this.userAgentData = e.message;
      }
    })();

    this.setScreenData();
  },
  async mounted() {
    this.loadHardwareDevice();
    await this.loadMediaDevices();
    await this.playVideo();

    this.$emit('previewVideo', this.$refs.prevVideo);
  },
  destroyed () {
    this.unsetScreenData();
  },
  methods: {
    setScreenData () {
      this.userScreenData = `orientation[${screen.orientation.type}], angle[${screen.orientation.angle}]`;

      this._screenChangeListener = this._screenChangeListener || ((event) => {
        this.setScreenData();
      });
      this.unsetScreenData();
      screen.orientation.addEventListener('change', this._screenChangeListener);
    },
    unsetScreenData () {
      screen.orientation.removeEventListener('change', this._screenChangeListener);
    },
    async loadHardwareDevice() {
      const info = this.Hardware;

      // cpu
      if(navigator.hardwareConcurrency){
        info.cpu = navigator.hardwareConcurrency;
      }

      // battery
      if(navigator.getBattery){
        const bt = info.battery.instance = await navigator.getBattery();
        const setInfo = () => {
          ['charging', 'chargingTime', 'level'].forEach(k => info.battery[k] = bt[k]);
        }
        setInfo();
        bt.onchargingchange = setInfo;
        bt.onlevelchange = setInfo;
      }

      // network
      {
        info.network.online = navigator.onLine;
        window.addEventListener('online', e => {
          info.network.online = navigator.onLine;
        })
        window.addEventListener('offline', e => {
          info.network.online = navigator.onLine;
        })
        if(navigator.connection){
          info.network.effectiveType = navigator.connection.effectiveType
          navigator.connection.addEventListener('change', e => {
            info.network.lastChangeDateTime = new Date();
            info.network.effectiveType = navigator.connection.effectiveType
          })
        }
      }
    },
    async loadMediaDevices () {
      const INIT = this.Device.init !== true;
      this.Device.init = true;

      this.Device.selected.video = localStorage.getItem('Device.selected.video');

      const loadDevices = async () => {
        return (await navigator.mediaDevices.enumerateDevices())
            .map(device => device.toJSON())
      };
      let devices = await loadDevices();
      for(const deviceKey of [
          'video',
        // 'audio'
      ]){
        const sample = devices.find(d => d.kind === `${deviceKey}input`);
        if(!sample) continue;

        if(!sample.label){
          try{
            const opt = {};
            opt[deviceKey] = true;
            const stream = await navigator.mediaDevices.getUserMedia(opt);
            stream.getTracks().forEach(t => t.stop());

            devices = await loadDevices();
          }catch(e){
            console.warn('load err:', deviceKey, e);
          }
        }

        const list = devices.filter(device => {
              return device.kind === `${deviceKey}input`;
            })

        this.Device.list[deviceKey] = list;

        if(!this.Device.selected[deviceKey]){
          this.Device.selected[deviceKey] = list[0].deviceId;
        }
      }
    },
    async applyVideoConstraints () {
      const track = this.stream.getTracks()[0];
      const newCons = JSON.parse(this.trackInfo.constraints);

      const cons = track.getConstraints();
      Object.assign(cons, newCons);
      console.log('# apply cons st:', cons);
      await track.applyConstraints(cons);
      console.log('# apply cons ed:', track.getConstraints());

      this.setTrackInfo();
    },
    onVideoPlay (e) {

    },
    async playVideo () {
      if(this.stream){
        this.stream.getTracks().forEach(t => {
          t.stop()
          this.stream.removeTrack(t);
        });
      }

      const settings = this.Device.settings.video;
      let video = Object.assign({
        deviceId: {exact: this.Device.selected.video}
      }, settings.resSets[settings.res]);
      try{
        this.stream = await navigator.mediaDevices.getUserMedia({
          video
        });
      }catch(e){
        console.error('getUserMedia err:', video, e);
        try{
          video = {
            deviceId: video.deviceId
          }
          const newStream = await navigator.mediaDevices.getUserMedia({
            video
          });
          if(!this.stream){
            this.stream = newStream;
          }else{
            this.stream.addTrack(newStream.getVideoTracks()[0]);
          }
        }catch(e1){
          console.error('getUserMedia err2:', video, e1);
        }
      }
      if(this.$refs.prevVideo.srcObject !== this.stream){
        this.$refs.prevVideo.srcObject = this.stream;
        localStorage.setItem('Device.selected.video', this.Device.selected.video);

        this.$emit('stream', {stream: this.stream});
      }
    },
    stopVideo () {
      if(!this.stream) return;
      this.stream.getTracks().forEach(t => t.stop());
    },
    setTrackInfo () {
      const track = this.stream.getTracks()[0];
      this.trackInfo.constraints = JSON.stringify( track.getConstraints(), null, ' ' );

      const video = this.$refs.prevVideo;
      const s = [
        `size: ${video.videoWidth} x ${video.videoHeight}`,
        JSON.stringify( track.getSettings(), null, ' ' )
      ];
      this.trackInfo.settings = s.join('\r\n');
    },
  }, // end of methods
}
</script>

<style scoped lang="scss">
.test-root {
  font-size: 14px;

  video {
    max-width: 100vh;
    max-height: 100vw;
  }

  .preview-video-layer {
    position: relative;
  }
}

</style>